import { useFlagMe420304ConnectCarrierWalkmeIntegration } from '@generated/flags/ME-420304-connect-carrier-walkme-integration';
import { FC, useEffect } from 'react';
import { initConnectCarrierWalkme } from '../util/walkme';

/**
 * Component that initializes WalkMe for the Carrier Portal
 * Only runs when the feature flag is enabled
 */
export const WalkMeInitializer: FC = () => {
  const isWalkMeEnabled = useFlagMe420304ConnectCarrierWalkmeIntegration();

  useEffect((): void | (() => void) => {
    if (isWalkMeEnabled) {
      // Delay initialization similar to the main app
      const timeoutId = setTimeout(() => {
        initConnectCarrierWalkme();
      }, 4000);

      return () => clearTimeout(timeoutId);
    }
  }, [isWalkMeEnabled]);

  // This component doesn't render anything visible
  return null;
};
